import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { EntityPageHeader } from '@/shared/components'
import { ProgrammeForm } from '../components'
import { useProgramme, useCreateProgramme, useUpdateProgramme } from '../hooks/use-programmes'
import type { TypeProgramme } from '@/shared/types/common'

export function ProgrammeFormPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const isEdit = !!id

  const { data: programme, isLoading } = useProgramme(id ? parseInt(id) : undefined)
  const createProgramme = useCreateProgramme()
  const updateProgramme = useUpdateProgramme()

  const handleSubmit = (data: {
    libelle: string
    type: TypeProgramme
    actif: boolean
    actions: Array<{ id?: number; actionId: number; jourDeclenchement: number }>
  }) => {
    if (isEdit) {
      updateProgramme.mutate(
        { id: parseInt(id!), data: { libelle: data.libelle, type: data.type, actions: data.actions } },
        { onSuccess: () => navigate('/programmes') },
      )
    } else {
      createProgramme.mutate(
        { libelle: data.libelle, type: data.type, actions: data.actions },
        { onSuccess: () => navigate('/programmes') },
      )
    }
  }

  if (isEdit && isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  return (
    <div>
      <EntityPageHeader
        title={
          isEdit
            ? t('programmes.editTitle', 'Modifier le programme')
            : t('programmes.createTitle', 'Créer un programme')
        }
        backTo="/programmes"
      />
      <ProgrammeForm
        programme={programme}
        onSubmit={handleSubmit}
        isPending={createProgramme.isPending || updateProgramme.isPending}
      />
    </div>
  )
}
